module.exports = __webpack_public_path__ + "static/media/boltOff_326.8870f91b.png";